import React from 'react'
import {
    HomeIcon, OfferIcon, OrdersIcon, ProfileIcon, SettingIcon, MyProfileIcon, ReferAFriendIcon,
    MyAccountIcon, NotificationsIcon, RewardsTransactionsIcon, OrderHistoryIcon, OfferActiveIcon,SpendingPreferenceIcon,
    HelpIcon, HomeActiveIcon, OrdersActiveIcon, PrivacyIcon, MailWhiteIcon, TermConditionIcon, FAQIcon, MoreInfoIcon,
    WalletWhiteIcon, PaymentsIcon, ParticipatingSchemesIcon, ServiceRequestIcon, CyprusFlagIcon, TopupIcon, GREFlagIcon, MapIcon, MapActiveIcon, PlaceActiveIcon, CardIcon, RedeemPassIcon, SubcriptionIcon, SubcriptionActiveIcon, WalletJournalBlackIcon, StoreActiveIcon, StoreIcon, WalletBlackIcon, InvoiceIcon, InvoiceActiveIcon,
    TabWalletActiveIcon,
    TabWalletIcon
} from './release/components/icons';
import { paths } from './portal.router.config'
import { getAppCfg } from './release/utils/common';
import { domainName, portal_config } from './portal.config';
import { Card } from '@material-ui/core';


export const pageConfig = [
    { title: 'home_title', icon: HomeIcon, route: paths.home, id: 'home', showMenu: true, showExpand: false, showHeader: true },
    { title: 'offers_title', icon: OfferIcon, route: paths.offers, id: 'offers', showMenu: true, showExpand: false, showHeader: true },
    { title: 'order_title', icon: OrdersIcon, route: paths.orders, id: 'orders', showMenu: true, showExpand: false, showHeader: true },
    { title: 'subcriptions_title', icon: SubcriptionIcon, route: paths.subcriptions, id: 'subcriptions', showMenu: true, showExpand: false, showHeader: true },
    { title: 'online_shop_title', icon: StoreIcon, route: paths.online_shop, id: 'online_shop', showMenu: true, showExpand: false, showHeader: true },
    { title: 'profile_title', icon: ProfileIcon, route: paths.profile, id: 'profile', showMenu: true, showExpand: true, showHeader: true },
]
export const pageConfigPlus = [
    { title: 'setting_title', icon: SettingIcon, route: paths.setting, id: 'setting', showMenu: true, showExpand: false, showHeader: false },
]

export const expandProfileConfig = {
    airlink:[
        { title: 'my_profile', icon: MyProfileIcon, route: paths.myProfile, id: 'my_profile', showMenu: false },
        { title: 'refer_a_friend', icon: ReferAFriendIcon, route: paths.referFriend, id: 'refer_friend' },
        { title: 'my_account', icon: MyAccountIcon, route: paths.orders, id: 'my_account', showMenu: false },
        { title: 'cards', icon: MyAccountIcon, route: paths.myCards, id: 'my_cards', showMenu: true },
        { title: 'wallet_journals', icon: WalletJournalBlackIcon, route: paths.wallet_journals, id: 'wallet_journals' },
        { title: 'order_history', icon: OrderHistoryIcon, route: paths.profile, id: 'order_history'},
        { title: 'topup_wallet', icon: TopupIcon, route: paths.topup_wallet, id: 'topup_wallet'},
        // { title: 'service_requests', icon: ServiceRequestIcon, route: paths.service_requests, id: 'service_requests', showMenu: false },
        { title: 'redeem_pass', icon: RedeemPassIcon, route: paths.redeem_pass, id: 'redeem_pass' },
        { title: 'mobile_pass_card', icon: WalletBlackIcon, route: paths.mobile_pass_card, id: 'mobile_pass_card' },
        { title: 'setting_title', icon: SettingIcon, route: paths.setting, id: 'setting', showMenu: false, showHeader: false },
        { title: 'more_info', icon: HelpIcon, route: paths.moreInfo, id: 'more_info', showMenu: true, showHeader: true },
    ],
}

export const myAccountConfig = {
    airlink:[
        { title: 'my_cards_orders', icon: PaymentsIcon, id: 'my_cards_orders', enable: true },
        { title: 'my_cards_rewards', icon: PaymentsIcon, id: 'my_cards_rewards', enable: true },
        { title: 'spending_preferences', icon: SpendingPreferenceIcon, id: 'spending_preferences', enable: true },
        { title: 'participating_schemes', icon: ParticipatingSchemesIcon, id: 'participating_schemes', enable: true },
    ],
}
export const menuFull = [
    { index: 0, title: 'home_title', icon: HomeIcon, iconActive: HomeActiveIcon, route: paths.home, id: 'home', showMenu: true },
    { index: 1, title: 'map_title', icon: MapIcon, iconActive: MapActiveIcon, route: paths.map, id: 'map', showMenu: true },
    { index: 2, title: 'offers_title', icon: OfferIcon, iconActive: OfferActiveIcon, route: paths.offers, id: 'offers', showMenu: true },
    { index: 3, title: 'order_title', icon: OrdersIcon, iconActive: OrdersActiveIcon, route: paths.orders, id: 'orders', showMenu: true },
    { index: 4, title: 'subcriptions_title', icon: SubcriptionIcon, iconActive: SubcriptionActiveIcon, route: paths.subcriptions, id: 'subcriptions', showMenu: false },
    { index: 5, title: 'online_shop_title', icon: StoreIcon, iconActive: StoreActiveIcon, route: paths.online_shop, id: 'online_shop', showMenu: false },
    { index: 6, title: 'account_title', icon: InvoiceIcon, iconActive: InvoiceActiveIcon, route: paths.invoice, id: 'invoice', showMenu: false },
    // { index: 7, title: 'Wallet', icon: TabWalletIcon, iconActive: TabWalletActiveIcon, route: paths.wallet, id: 'wallet', showMenu: true },
    { index: 8, title: 'service_requests', icon: ServiceRequestIcon, iconActive: ServiceRequestIcon, route: paths.service_requests, id: 'service_requests', showMenu: true },
]
export const menuWithoutOrderConfig = [
    { index: 0, title: 'home_title', icon: HomeIcon, iconActive: HomeActiveIcon, route: paths.home, id: 'home', showMenu: true },
    { index: 1, title: 'offers_title', icon: OfferIcon, iconActive: OfferActiveIcon, route: paths.offers, id: 'offers', showMenu: true },
]
export const menuWithoutOfferConfig = [
    { index: 0, title: 'home_title', icon: HomeIcon, iconActive: HomeActiveIcon, route: paths.home, id: 'home', showMenu: true },
    { index: 1, title: 'offers_title', icon: OfferIcon, iconActive: OfferActiveIcon, route: paths.offers, id: 'offers', showMenu: true },
]


export const addressCountries = [
    {
        label: 'Cyprus',
        icon: CyprusFlagIcon,
        value:'CY'
    }
]
